var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '../typography';
import styles from './input.module.css';
export const Input = (_a) => {
    var { size = 'small', label, required, control } = _a, props = __rest(_a, ["size", "label", "required", "control"]);
    return (_jsx(FormControl, { fullWidth: true, children: _jsx(FormControlLabel, { labelPlacement: "top", disableTypography: true, control: control || _jsx(TextField, Object.assign({ size: size }, props, { fullWidth: true })), label: _jsxs(Typography, { variant: "subtitle1", className: styles.label, children: [label, required && _jsx("span", { className: "text-red-500", children: " *" })] }) }) }));
};
export default Input;
